import styled from 'styled-components'

const Dots = styled.span`
  &::after {
    display: inline-block;
    animation: ellipsis 1.25s infinite;
    content: '.';
    width: 1em;
    text-align: left;
  }
  @keyframes ellipsis {
    0% {
      content: '.';
    }
    2% {
      content: '..';
    }
    6% {
      content: '...';
    }
  }
`

export default Dots
